(function() {
  // Store pattern URLs
  const patterns = [
    'https://cdn.shopify.com/s/files/1/0927/8626/2361/files/Frame1.svg?v=1742358447',
    'https://cdn.shopify.com/s/files/1/0927/8626/2361/files/Group1.svg?v=1742369171',
    'https://cdn.shopify.com/s/files/1/0927/8626/2361/files/Group2.svg?v=1742369171',
    'https://cdn.shopify.com/s/files/1/0927/8626/2361/files/Group3.svg?v=1742369169'
  ];

  // Corner positions
  const corners = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];

  // Get all section elements except those with id containing main-product
  const sections = document.querySelectorAll('section:not([id*="main-product"])');

  // Add a random pattern to each section
  sections.forEach(section => {
    // Choose a random pattern
    const randomPattern = patterns[Math.floor(Math.random() * patterns.length)];

    // Choose a random corner
    const randomCorner = corners[Math.floor(Math.random() * corners.length)];

    // Create the pattern element
    const patternElement = document.createElement('img');
    patternElement.src = randomPattern;
    patternElement.classList.add('pattern', randomCorner);

    // Add the pattern to the section
    section.appendChild(patternElement);
  });
})();